import React from "react";

/**
 * Placeholder for a shop tab while the catalog's categories are loading.
 *
 * Mirrors TabDropdown's box model so the nav doesn't visibly reflow when the
 * real tab swaps in: the same `.tab-item-wrapper` > `.tab-button` pair (which
 * supplies the px-4 py-2.5 padding and the inline-flex line box) plus the
 * `border-b-2` a real tab always carries. Inside sits a shimmer bar roughly
 * the width of the domain name it stands in for.
 *
 * aria-hidden because it names nothing — screen readers get the announcement
 * from the live region below instead of a phantom nav entry.
 */
const TabDropdownSkeleton: React.FC = () => {
  return (
    <div className="tab-item-wrapper relative" data-testid="tab-skeleton">
      <span
        className="tab-button border-b-2 border-transparent"
        aria-hidden="true"
      >
        <span className="h-4 w-16 rounded bg-gray-200 animate-pulse" />
      </span>
      <span className="sr-only" role="status">
        Loading shop categories
      </span>
    </div>
  );
};

export default TabDropdownSkeleton;
